"use strict";
var __createBinding =
  (this && this.__createBinding) ||
  (Object.create
    ? function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        Object.defineProperty(o, k2, {
          enumerable: true,
          get: function () {
            return m[k];
          },
        });
      }
    : function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
      });
var __exportStar =
  (this && this.__exportStar) ||
  function (m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
  };
Object.defineProperty(exports, "__esModule", { value: true });
exports.logKeyHandler = exports.initNamespacedLog = void 0;
var global_1 = require("./global");
var sentry_1 = require("./sentry");
var global_2 = require("./global");
Object.defineProperty(exports, "setLogConfig", {
  enumerable: true,
  get: function () {
    return global_2.setLogConfig;
  },
});
Object.defineProperty(exports, "setLogOutput", {
  enumerable: true,
  get: function () {
    return global_2.setLogOutput;
  },
});
__exportStar(require("./types"), exports);
/** @description initializes a global Log object - on the window object
 *
 * IMPORTANT: make EXTRA SURE that this call is over before starting to use the global Log object!
 */
exports.initNamespacedLog = function (config) {
  global_1.setLogConfig(config);
  if (_LogContext.logConfig.sentry) sentry_1.initSentry(_LogContext.logConfig.sentry);
  return global_1.setLogOutput(config.initialLogOutput, config.remoteCode);
};
/** @description This function needs to be called by the app to enable the debug menu & the code inputs
 * @returns true if the key was handled (in this case don't use it in the app), false otherwise
 */
exports.logKeyHandler = function (key, type) {
  var _a;
  if ((_a = _LogContext.logMenu) === null || _a === void 0 ? void 0 : _a.onKey(key, type)) {
    return true;
  }
  return false;
};
//# sourceMappingURL=index.js.map
